import { SelectOption } from '../../../../_interfaces/select-field.interface';

export enum SearchParamKeys {
  NAME = 'name',
  FIRST_NAME = 'first_name',
  LAST_NAME = 'last_name',
  USER_FIRST_NAME = 'user_first_name',
  USER_LAST_NAME = 'user_last_name',
  MERCHANT = 'merchant',
  CARD_NAME = 'card_name',
  REQUESTER = 'requester',
  SEARCH = 'search',
  EMPLOYEE = 'employee',
}

export const CardsSearchOptions: SelectOption[] = [
  {
    option: 'First or last name',
    value: SearchParamKeys.NAME,
  },
];

export const EmployeeSearchOptions: SelectOption[] = [
  {
    option: 'First or last name',
    value: SearchParamKeys.NAME,
  },
];

//Recurring or Scheduled
export const TopUpSearchOptions: SelectOption[] = [
  {
    option: 'Card name',
    value: SearchParamKeys.CARD_NAME,
  },
  {
    option: 'Cardholder first name',
    value: SearchParamKeys.USER_FIRST_NAME,
  },
  {
    option: 'Cardholder last name',
    value: SearchParamKeys.USER_LAST_NAME,
  },
];

export const ImmediateTopUpSearchOptions: SelectOption[] = [
  {
    option: 'Card name',
    value: SearchParamKeys.CARD_NAME,
  },
  {
    option: 'Transferred by',
    value: SearchParamKeys.EMPLOYEE,
  },
];

export const TransactionSearchOptions: SelectOption[] = [
  {
    option: 'First name',
    value: SearchParamKeys.FIRST_NAME,
  },
  {
    option: 'Last name',
    value: SearchParamKeys.LAST_NAME,
  },
  {
    option: 'Merchant',
    value: SearchParamKeys.MERCHANT,
  },
];

export const CategoriesSearchOptions: SelectOption[] = [
  {
    option: 'Name',
    value: SearchParamKeys.NAME,
  },
];

export const WithdrawalsSearchOptions: SelectOption[] = [
  {
    option: 'Requested by',
    value: SearchParamKeys.REQUESTER,
  },
];

export const VideosSearchOptions: SelectOption[] = [
  {
    option: 'Tutorial',
    value: SearchParamKeys.SEARCH,
  },
];
